import { makeStyles } from '@material-ui/core';
import { white } from '@signaturit/react-components-library';

export type UserAlertNotificationsFlowStyles = {
    typeError: string;
    content: string;
    button: string;
};

export const useUserAlertNotificationsFlowStyles = makeStyles(() => ({
    content: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    typeError: {
        backgroundColor: '#000',
        color: white,
    },
    button: {
        marginLeft: 16,
        width: 134,
    },
}));
